import React from "react";
import "./CaloriesPerDay.css";
import { AiOutlineCalendar } from "react-icons/ai";

export default function CaloriesPerDay(props) {
  const calorieData = props.calorieData;
  const showDatePicker = () => {
    props.onShowDatePicker();
  };

  const CalorieRegulationHandler = () => {
    props.onShowAlert();
    props.onShowCalorieRegulation();
  };

  return (
    <div className="caloriesPerDay">
      <div className="caloriesPerDayHeader centeredFlex">
        <span onClick={showDatePicker}>{props.shamsiDate}</span>
        <AiOutlineCalendar className="calendarIcon" />
      </div>
      <div className="caloriesPerDayContent centeredFlex">
        <div className="caloriesPerDayContentRight centeredFlex">
          <div className="definedCalories centeredFlex">
            <img src="/images/wheat.svg" alt="wheat icon" />
            <span>
              {calorieData ? calorieData.total_calorie.toFixed(1) : 0}
            </span>
            <p>تعیین شده</p>
          </div>
          <div
            className="calorieAdjustment centeredFlex"
            onClick={CalorieRegulationHandler}
          >
            تنظیم کالری - {props.manual ? "دستی" : "اتومات"}
          </div>
        </div>
        <div className="caloriesPerDayContentLeft centeredFlex">
          <div className="caloriesConsumed centeredFlex">
            <span>
              {calorieData
                ? Number.isInteger(calorieData.consumed_calorie)
                  ? calorieData.consumed_calorie.toFixed(1)
                  : calorieData.consumed_calorie.toFixed(2)
                : 0}
            </span>
            <p>مصرف شده</p>
          </div>
          <div className="netCalories centeredFlex">
            <span>0</span>
            <p>خالص</p>
          </div>
        </div>
      </div>
      <div className="remainingCalories centeredFlex">
        <div className="remainingCaloriesText">
          <span>
            {(calorieData.remaining_calorie >= 0
              ? calorieData.remaining_calorie
              : 0
            ).toFixed(1)}
          </span>
          کالری دیگر جا دارید!
        </div>
        <div
          className="remainingCaloriesProgressBar"
          style={{
            width: `${
              (calorieData.consumed_calorie / calorieData.total_calorie) * 100
            }%`,
          }}
        ></div>
      </div>
    </div>
  );
}
